import React, { useState, useCallback} from "react";
import { Link, useNavigate } from "react-router-dom";

import _, { debounce } from "lodash";
import userSearchIcon from "../../assests/search-icon.png";
import { AiOutlinePieChart } from "react-icons/ai";
import { IoPersonAddOutline } from "react-icons/io5";
import { FiUserPlus } from "react-icons/fi";
import { FiUserMinus } from "react-icons/fi";

import { IoPersonAddSharp } from "react-icons/io5";
import { FaChartLine, FaChartPie } from "react-icons/fa";
import { BsBookmarkPlusFill } from "react-icons/bs";
import { MdInsights, MdOutlinePlaylistRemove } from "react-icons/md";

import { CiBookmarkPlus } from "react-icons/ci";
import RecallIcon from "../../assests/recallIcon.svg";
import ViewRecalledEpisodes from "../../assests/viewrecalledepisodes.svg";
import { Spinner } from "../../common/Helper";
import { toast, ToastContainer } from "react-toastify";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import CircularProgress from "@mui/material/CircularProgress";
import {
  getauditData,
  getAuditFiles,
  getAuditRows,
  getAuditRowsByFileName,
  getSearchData,
  getSearchRecommendations,
  recall_episode,
  getUsers,
  episodeAssignedUsers,
  flag_and_unflag,
  episodeUnAssignedUsers,
  fetchUnassignedEpisodes,
  getCsvColoumns
} from "../../api/Service";
import { Button, Dropdown, Form } from "react-bootstrap";
import assgineTickIcon from "../../assests/assgine-tick.png";
import AssignedToModal from "../filters/AssignedToModal";
import "./Sidenavbar.css";
import { Divider, FormControlLabel, IconButton, List, Menu, TextField,Typography,MenuItem,Checkbox,ListSubheader, Tooltip, Box} from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import HideImageIcon from "@mui/icons-material/HideImage";
import { useChatContext } from "../../../../../context";

export default function SidenavbarTemp({
  mode,
  setMode,
  updatedAuditRows,
  handleRefreshClick,
  setAuditDetails,
  setIsRowsLoading,
  isRowsLoading, 
  getAuditRowsByFilter,
  appliedFilters,
  setAppliedFilters,
  setHasMore,
  setAuditRows,
  setflagAuditRows,
  flagauditRows,
  getAuditRowsData,
  setPage,
  editFlageData,
  selectedEpisodeRows,
  setSelectedEpisodeRows,
  isAllEpisodesSelected,
  setIsAllEpisodesSelected,
  recall_page,
  setRecall_page,
  searchEpisodeIdentifier,
  setSearchEpisodeIdentifier,
  recommendations,
  setRecommendations,
  selectAllFiles,
  setSelectAllFiles,
  selectedColumns,
  toggleColumnSelection,
  isAssigned,
  setIsAssigned,
  unassined_page,
  setUnassined_page,
  addUnassignReason,
  setAddUnassignReason
}) {
    const {  webWorkFlow } = useChatContext();
  const [openUserAssgineeModal, setOpenUserAssgineeModal] = useState(false);
  const [selectedAssgineeUser, setSelectedAssgineeUser] = useState(null);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [searchAssgineeUserName, setSearchAssgineeUserName] = useState("");
  const [assgineCurrentPage, setAssgineCurrentPage] = useState(1);
  const [getAllUsers, setGetAllUsers] = useState([]);
  const [openConfirmAssgineModal, setOpenConfirmAssgineModal] = useState(false);
  const [isAssigneLoading, setIsAssigneLoading] = useState(false);
  const [isUnassignLoading,setIsUnassignLoading] = useState(false)
  const assginedUserId = JSON.parse(sessionStorage.getItem("userId"));
  const [addAssignReason, setAddAssignReason] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const [csvColumn,setCsvColumn] = useState(null)
 const [csvCurrentPage, setCsvCurrentPage] = useState(1);
 const [hasMoreCsvColumns, setHasMoreCsvColumns] = useState(true);
 const [loadingMoreCsvColumns, setLoadingMoreCsvColumns] = useState(false);
 const [csvColumnSearch, setcsvColumnSearch] = useState("");
 const { storeCsvColumns,setStorCSVeColumns,checkedStoreColumns,setCheckedStoreColumns} = webWorkFlow
  const [filtersObj, setFiltersObj] = useState({ ...appliedFilters });
  const [showColumnsDropdown, setShowColumnsDropdown] = useState(false);
  const [openConfirmUnAssgineModal, setOpenConfirmUnAssgineModal] = useState(false);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const admin = permissions?.admin || false;
   const navigate = useNavigate();
   const showUnassignLoadingText =()=>{
    return(<div className="loading-assigne-modal-overlay-fade z-3">
      <div className="loading-modal-content-section">
        <p>Unassigning is in progress, Please wait...</p>
        <Spinner />
      </div>
    </div>)
    
   }
  const showLoadingText = () => {
    return (
      <div className="loading-assigne-modal-overlay-fade z-3">
        <div className="loading-modal-content-section">
          <p>Assigning is in progress, Please wait...</p>
          <Spinner />
        </div>
      </div>
    );
  };

   const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const filteredColumns = selectedColumns.filter((col) =>
    col.label.toLowerCase().includes(search.toLowerCase())
  );
  const handleDowloadColumnCsvOpen = (event) => {
    setCsvColumn(event.currentTarget);
    handleCsvColumns()
  };
  const handleDowloadColumnCsvClose = () => {
    setCsvColumn(null);
  };
const handleSearchChange = (value) => {
  setcsvColumnSearch(value);
  setCsvCurrentPage(1);
  setStorCSVeColumns([]);
  handleCsvColumns(false);
};
  const handleCsvColumns = async (load_more = false) => {
  try {
    // Start loader
    setLoadingMoreCsvColumns(true);

    const nextPage = load_more ? csvCurrentPage : 1;

    const response = await getCsvColoumns(csvColumnSearch, nextPage);
    const { columns } = response;

    // Merge and remove duplicates based on `key`
    // const mergedColumns = [
    //   ...new Map(
    //     [...(load_more ? storeCsvColumns : []), ...columns].map((item) => [
    //       item.key,
    //       item,
    //     ])
    //   ).values(),
    // ];
     const mergedColumns = load_more
      ? [
          ...new Map(
            [...storeCsvColumns, ...columns].map(item => [item.key, item])
          ).values(),
        ]
      : columns;

    // Store results
    setStorCSVeColumns(mergedColumns);

    // Pagination control
    setHasMoreCsvColumns(columns.length > 0);
    setCsvCurrentPage(nextPage + 1);
  } catch (error) {
    console.error("Error fetching CSV columns:", error);
    setHasMoreCsvColumns(false);
    setCsvCurrentPage(1);

    if (!load_more) {
      setStorCSVeColumns([]);
    }
  } finally {
    setLoadingMoreCsvColumns(false);
  }
};

// const storeColumnSelection = (columnKey) => {
//   setCheckedStoreColumns((prev) => {
//     const updatedColumns = prev.includes(columnKey)
//       ? prev.filter((key) => key !== columnKey)
//       : [...prev, columnKey];

//     // Update appliedFilters.csv_selected_list
//     setAppliedFilters((filters) => ({
//       ...filters,
//       csv_selected_list: updatedColumns,
//     }));

//     return updatedColumns;
//   });
// };

// const handleSelectAll = (event) =>{
//   if(event.target.checked){
//     const allKeys = storeCsvColumns.map((col) =>col.key)
//     setCheckedStoreColumns(allKeys)
//     setAppliedFilters((filters) =>({
//       ...filters,
//       csv_selected_list:allKeys
//     }))
//   }else{
//     setCheckedStoreColumns([])
//     setAppliedFilters((filters) =>({
//       ...filters,
//       csv_selected_list:[]
//     }))
//   }

// }

const storeColumnSelection = (columnKey) => {
  setAppliedFilters((filters) => {
    if (filters.selectAll) {
      const isDeselected = filters.deselected_list.includes(columnKey);
      return {
        ...filters,
        deselected_list: isDeselected
          ? filters.deselected_list.filter((k) => k !== columnKey)
          : [...filters.deselected_list, columnKey],
      };
    } else {
      const updated = checkedStoreColumns.includes(columnKey)
        ? checkedStoreColumns.filter((k) => k !== columnKey)
        : [...checkedStoreColumns, columnKey];
      return {
        ...filters,
        csv_selected_list: updated,
      };
    }
  });

  setCheckedStoreColumns((prev) =>
    appliedFilters.selectAll
      ? prev // no change in selectAll mode
      : prev.includes(columnKey)
      ? prev.filter((k) => k !== columnKey)
      : [...prev, columnKey]
  );
};

const handleSelectAll = (event) => {
  if (event.target.checked) {
    setAppliedFilters((filters) => ({
      ...filters,
      selectAll: true,
      csv_selected_list: [], 
      deselected_list: [],
    }));

    setCheckedStoreColumns(storeCsvColumns.map((col) => col.key)); 
  } else {

    setAppliedFilters((filters) => ({
      ...filters,
      selectAll: false,
      csv_selected_list: [],
      deselected_list: [],
    }));

    setCheckedStoreColumns([]);
  }
};




  const cancelAssignReason = () => {
    setOpenConfirmAssgineModal(false);
  };
    const episodeUnassgineHandler = () => {
      if(selectedEpisodeRows && selectedEpisodeRows?.length > 0){
        setOpenConfirmUnAssgineModal(true);
      }else{
        toast.info("Please Select Some Episodes")
      }
    }
   const callAPI = () => {
     episodeUnAssignedUsers(selectedEpisodeRows, assginedUserId, addUnassignReason, isAllEpisodesSelected, appliedFilters, !recall_page,appliedFilters.header_id)
       .then((res)=>{
         toast.success(res.message ? res.message : "Episodes are unassigned and e-mail has been sent successfully");
         setTimeout(()=>{
          window.location.reload()
         },3000)
         
         setOpenConfirmUnAssgineModal(false);
       })
       .catch((err)=>{
         toast.error("Episode unassigned failed");
         setOpenConfirmUnAssgineModal(true);
         console.log("Episode unassigned failed::", err.message)
       })
       .finally(()=>{setIsUnassignLoading(false)})
   }   
  const fetchUsers = useCallback(
    debounce((userName) => {
      setLoadingUsers(true);
      setHasMoreUsers(true);
      getUsers(userName, assgineCurrentPage)
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          }
          const { users } = res.data;
          setGetAllUsers(users);
        })
        .catch((err) => {
          console.log("No Users Found::", err.message);
          // setNoUsersMessage(err.message)
          setGetAllUsers([]);
        })
        .finally(() => setLoadingUsers(false));
    }, 500),
    []
  );
  const handleAssignReason = () => {
    setOpenConfirmAssgineModal(!openConfirmAssgineModal);
    episodeUserAssignments();
  };
  const episodeUserAssignments = useCallback(() => {
    setIsAssigneLoading(true);
    episodeAssignedUsers(
      selectedEpisodeRows,
      selectedAssgineeUser?.user_id,
      assginedUserId,
      addAssignReason,
      isAllEpisodesSelected,
      appliedFilters,
      recall_page,
      appliedFilters.header_id,
      unassined_page
    )
      .then((repo) => {
        if (repo?.response?.status === 401) {
          const errMessage = repo?.response?.data?.message.includes(
            "TypeError: Cannot read properties of undefined"
          )
            ? "Assign failed"
            : repo?.response?.data?.message || "An unknown error occurred";
          toast.error(errMessage);
          console.log(
            "Episode assigned failed::",
            repo?.response?.data?.message
          );
          setGetAllUsers([]);
          setSearchAssgineeUserName("");
          setSelectedAssgineeUser(null);
          setAssgineCurrentPage(1);
        } else {
          toast.success(repo.message);
          setSelectedEpisodeRows([]);
          setIsAllEpisodesSelected(false);
          window.location.reload();
          setHasMoreUsers(true);
        }
      })
      .catch((err) => {
        const errMessage = err.message.includes("Cannot read properties")
          ? "Assign failed"
          : err.message;
        toast.error("Episodes Assignement Failed");
        console.log("Episode assigned failed::", err.message);
        setGetAllUsers([]);
        setSearchAssgineeUserName("");
        setSelectedAssgineeUser(null);
        setAssgineCurrentPage(1);
      })
      .finally(() => setIsAssigneLoading(false));
  }, [
    selectedEpisodeRows,
    selectedAssgineeUser,
    assginedUserId,
    addAssignReason,
    isAllEpisodesSelected,
    filtersObj,
  ]);
  const assgineeModalHandle = (e) => {
    setOpenUserAssgineeModal((prev) => {
      const modalIsOpened = !prev;
      if (modalIsOpened) {
        setHasMoreUsers(true);
        setLoadingUsers(true);
        getUsers(searchAssgineeUserName, assgineCurrentPage)
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            }
            const { users } = res.data;
            setGetAllUsers(users);
          })
          .catch((err) => {
            console.log("No Users Found::", err.message);
          })
          .finally(() => setLoadingUsers(false));
      } else {
        setGetAllUsers([]);
        setSearchAssgineeUserName("");
        setSelectedAssgineeUser(null);
        setAssgineCurrentPage(1);
      }
      return modalIsOpened;
    });
  };
  const searchAssgineUsers = (event) => {
    const { value } = event.target;
    setSearchAssgineeUserName(value);
    fetchUsers(value);
  };
  const getMoreUsers = async (assgineCurrentPage, load_more) => {
    try {
      setLoadingUsers(true);
      const response = await getUsers(
        searchAssgineeUserName,
        assgineCurrentPage
      );
      const { users } = response.data;
      const mergedUsers = [
        ...new Map(
          [...getAllUsers, ...users].map((item) => [item.user_id, item])
        ).values(),
      ];
      if (load_more) {
        setGetAllUsers(mergedUsers);
      } else {
        setGetAllUsers(users);
      }
      setHasMoreUsers(true);
      const newPage = assgineCurrentPage + 1;
      setAssgineCurrentPage(newPage);
    } catch (error) {
      console.log("Error fetching users:", error);
      setHasMoreUsers(false);
      setAssgineCurrentPage(1);
      if (!load_more) {
        setGetAllUsers([]);
      }
    } finally {
      setLoadingUsers(false);
    }
  };
  const handleAssgintoUsers = (data) => {
    if (selectedEpisodeRows && !selectedEpisodeRows?.length > 0) {
      toast.info("Please Select Some Episodes");
    }
    if (selectedEpisodeRows && selectedEpisodeRows?.length > 0) {
      if (selectedAssgineeUser?.user_id === data?.user_id) {
        return;
      }
      setSelectedAssgineeUser(data);
    }
  };
  const assginToHandler = (e) => {
    if (selectedEpisodeRows && !selectedEpisodeRows.length > 0) {
      toast.info("Please Select Some Episodes");
    } else {
      if (selectedAssgineeUser === null) {
        toast.info("Please Select User");
      } else {
        setOpenUserAssgineeModal(false);
        setOpenConfirmAssgineModal(true);
        setSearchAssgineeUserName("");
      }
    }
  };
    const getUnassignedEpisodes = ()=>{
      console.log(assginedUserId,"assigned by")
      fetchUnassignedEpisodes( assginedUserId, filtersObj, !recall_page,appliedFilters.header_id)
    .then((res)=>{
      // toast.success(res.message ? res.message : "Episodes are unassigned and e-mail has been sent successfully");
      // window.location.reload()
      // console.log(res?.unassigned_episodes);
      setAuditRows(res?.unassigned_episodes)
    })
    .catch((err)=>{
  
      toast.error("No Data");
      
      console.log("Episode unassigned failed::", err.message)
    })
  }
  const handleFlagUnFlag = () => {
    console.log(appliedFilters.header_id, "newobj");
    if (selectedEpisodeRows && !selectedEpisodeRows?.length > 0) {
      toast.info("Please Select Some Episodes");
    } else if (!flagauditRows) {
      flag_and_unflag(
        selectedEpisodeRows,
        selectedAssgineeUser?.user_id,
        assginedUserId,
        addAssignReason,
        isAllEpisodesSelected,
        filtersObj,
        !recall_page,
        appliedFilters.header_id
      )
        .then((res) => {
          // toast.success(res.data.message);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.message);
          console.log("Episode assigned failed::", err.message);
        });
    } else {
      flag_and_unflag(
        selectedEpisodeRows,
        selectedAssgineeUser?.user_id,
        assginedUserId,
        addAssignReason,
        isAllEpisodesSelected,
        filtersObj,
        !recall_page,
        appliedFilters.header_id
      )
        .then((res) => {
          //toast.success(res.data.message);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.message);
          console.log("Episode assigned failed::", err.message);
        });
    }
  };
  return (
    <div className="side-navbar-component">
      {/* <div className="side-navbar-item" onClick={() =>navigate("/workflow-dashboard")}>
        <AiOutlinePieChart style={{  }} />
        <span>Dashboard</span>
      </div> */}

 <Dropdown className="workflow-dashboard-dropdown-section">
      <Dropdown.Toggle className="workflow-dashboard-dropdown-toggle">
        <AiOutlinePieChart style={{marginRight: '13px', fontSize: "20px"}} />
        Dashboard
      </Dropdown.Toggle>

      <Dropdown.Menu className="workflow-dashboard-dropdown-menu">
        <Dropdown.Item href="/workflow-dashboard" className="workflow-dashboard-dropdown-item">
        <div
        // onClick={() => navigate("/workflow-dashboard")}
      >
        <FaChartLine size={15} style={{marginRight: "13px"}}/> 
        <span>Audit Performance and Results</span>
      </div>
        </Dropdown.Item>
        <Dropdown.Item href="/live-findings" className="workflow-dashboard-dropdown-item">
        <MdInsights size={15} style={{marginRight: "13px"}}  />
        Live Findings and Benefits</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      <div className="side-navbar-item dropdown-navbar-item">
        <Dropdown
          className="dropdown-assgine"
          show={openUserAssgineeModal}
          onToggle={assgineeModalHandle}
          autoClose="outside"
        >
          <Dropdown.Toggle
            style={{
              backgroundColor: "transparent !important",
              border: "none !important",
              height: "25px",
              boxShadow: "none !important",
            }}
            className={`dropdown-toggle-header ${
              openUserAssgineeModal ? "open" : "close"
            }`}
          >
            <FiUserPlus  />
            <span>Assign</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="assgine-modal-section">
            <Dropdown.Item
              eventKey={openUserAssgineeModal}
              className="assgine-dropdown-item"
            >
              <div className="assigne-search-section">
                <img
                  className="assigne-search-icon"
                  src={userSearchIcon}
                  alt={"userSearchIcon"}
                />
                <input
                  className="assgine-search-input"
                  type="text"
                  value={searchAssgineeUserName}
                  onChange={searchAssgineUsers}
                  placeholder="Search by Username or Email"
                />
              </div>
              <InfiniteScroll
                className="assgine-modal-body"
                hasData={hasMoreUsers}
                loadMore={() => getMoreUsers(assgineCurrentPage, true)}
                isLoading={loadingUsers}
              >
                {getAllUsers && getAllUsers?.length > 0
                  ? getAllUsers?.map((user, index) => {
                      return (
                        <div
                          className={`assigne-user-section ${
                            selectedAssgineeUser?.user_id === user?.user_id
                              ? " active"
                              : ""
                          }`}
                          onClick={() => handleAssgintoUsers(user)}
                        >
                          <div className="assigne-card">
                            <p>
                              <span className="assgine-user-name-icon">
                                {user?.username ? user?.username[0] : ""}
                              </span>
                            </p>
                            <p className="assigne-user-email-card">
                              <span className="assign-username">
                                {user?.username
                                  ? user?.username
                                  : "User not found"}
                              </span>
                              <span className="assign-email">
                                {user?.email ? user?.email : ""}
                              </span>
                            </p>
                          </div>
                          <div className="">
                            {selectedAssgineeUser?.user_id === user?.user_id ? (
                              <img src={assgineTickIcon} alt="" />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      );
                    })
                  : !loadingUsers && (
                      <p className="no-usersfound">No Users Found</p>
                    )}
              </InfiniteScroll>
              <div className="assgine-actions-btn">
                <button className="assigne-save-btn" onClick={assginToHandler}>
                  Assign
                </button>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {isAssigneLoading && showLoadingText()}
        {openConfirmAssgineModal && (
          <AssignedToModal
            handleAssignReason={handleAssignReason}
            cancelAssignReason={cancelAssignReason}
            addAssignReason={addAssignReason}
            setAddAssignReason={setAddAssignReason}
          />
        )}
      </div>
      {/* unassign button */}
      {recall_page&&admin&&<div className="side-navbar-item " onClick={episodeUnassgineHandler}><FiUserMinus 
                          style={{
                            width: "20px",
                            height: "20px",
                            textAlign: "center",
                          }}  />
                            <span >UnAssign</span>
                          </div>}
       {!unassined_page&&!recall_page&&<div className="side-navbar-item " onClick={episodeUnassgineHandler}><FiUserMinus 
                          style={{
                            width: "20px",
                            height: "20px",
                            textAlign: "center",
                          }}  />
                            <span >Unassign</span>
                          </div>}
                          {isUnassignLoading && showUnassignLoadingText()}
                          {openConfirmUnAssgineModal && (
         <div className="unassign-reason-modal-overlay-fade z-3">
         <div className="unassign-reason-modal-content-section">
            <div className="unassign-reason-modal-content-header">
             <p>Add Specific Reason</p>
           </div>
           <div className="unassign-reason-modal-content-body">
           <div className="unassign-reason-textarea">
             <textarea 
               className="unassign-search-textarea"
               type="text"
               rows="4"
               value={addUnassignReason}
               onChange={(e) => setAddUnassignReason(e.target.value)}
               placeholder="Add the reason"/>
           </div>
           </div>
           <div className="unassign-reason-actions-btn">
             <button className="unassign-reason-btn-cancel" onClick={() => {
              setAddUnassignReason("")
              setOpenConfirmUnAssgineModal(false)
             }}>
               Cancel
             </button>
             <button className="unassign-reason-btn-save" onClick={() => {
              console.log("ram")
              setAddUnassignReason("")
              setOpenConfirmUnAssgineModal(false)
              console.log(isUnassignLoading,"ram")
              setIsUnassignLoading(true)
              callAPI()
             }}>
               Ok
             </button>
           </div>
         </div>
       </div>
      )}
                           {admin&&!isAssigned &&<div onClick={()=>{
                localStorage.removeItem("breadcrumbClick")
                setSearchEpisodeIdentifier("");
                setRecommendations([]);
                setflagAuditRows(false);
                setRecall_page(false);
                setIsAssigned(true);
                setUnassined_page(true);
                setIsAllEpisodesSelected(false);
                setSelectAllFiles(false)
                setFiltersObj({
                  fileType: [],
                  priorityValue: [],
                  status: [],
                  assigned_to: [],
                  assigned_by: [],
                  case_mix_speciality: [],
                  insurerIdentifier: [],
                  codedBy: [],
                  fromAdmissionDate: "",
                  toAdmissionDate: "",
                  fromSeparationDate: "",
                  toSeparationDate: "",
                  length_of_stay: [],
                })
                setAppliedFilters({
                  insurer_identifier: [],
                  priority_value: [],
                  episode_identifier:[],
                  status: [],
                  file_type: [],
                  header_id: [],
                  coder_name: [],
                  admission_date_from: "",
                  admission_date_to: "",
                  separation_date_from: "",
                  separation_date_to: "",
                  length_of_stay: [],
                  assigned_by:[],
                  assigned_to: [],
                  audit_ref_no:[],
                  uploaded_by_user_name : [],
                  hcp_line_updated_at : [],
                  short_description:[],
                  case_mix_speciality:[],
                  drg:[]
                });
                //sessionStorage.setItem("flagStatus",flagauditRows);
                // Clear existing rows and reset pagination
                //setIsRowsLoading(true);
                setAuditRows([]);
                setPage(1);
                setHasMore(true);
                getUnassignedEpisodes()
              }} className="side-navbar-item"><MdOutlinePlaylistRemove className="navbar-icon"/>
                <span className="">
                     Unassigned Episodes
                    </span>
              </div>}
     {!unassined_page&&<div className="side-navbar-item" onClick={handleFlagUnFlag}>
        <img
          src={RecallIcon}
          alt="Recall Icon"
          className="icon-style"
          style={{ width: "28px", height: "28px", color: "gray" }}
        />
        <span>{!flagauditRows ? "Recall" : "Reflag"}</span>
      </div>} 
      {!flagauditRows && (
        <div className="side-navbar-item">
          <img
            src={ViewRecalledEpisodes}
            alt="Recall Icon"
            className="icon-style"
            style={{ width: "28px", height: "28px", color: "gray" }}
          />
          {/* <span>Recalled Episodes</span> */}
          <span
            className=""
            onClick={() => {
              localStorage.removeItem("breadcrumbClick");
              //  setSearchEpisodeIdentifier("");
              setRecommendations([]);
              setflagAuditRows(true);
              setRecall_page(true);
              setIsAssigned(false);
              setUnassined_page(false);
              setIsAllEpisodesSelected(false);
              setSelectAllFiles(false);
              setFiltersObj({
                  fileType: [],
                  priorityValue: [],
                  status: [],
                  assigned_to: [],
                  assigned_by: [],
                  case_mix_speciality: [],
                  insurerIdentifier: [],
                  codedBy: [],
                  fromAdmissionDate: "",
                  toAdmissionDate: "",
                  fromSeparationDate: "",
                  toSeparationDate: "",
                  length_of_stay: [],
                })
                setAppliedFilters({
                  insurer_identifier: [],
                  priority_value: [],
                  episode_identifier:[],
                  status: [],
                  file_type: [],
                  header_id: [],
                  coder_name: [],
                  admission_date_from: "",
                  admission_date_to: "",
                  separation_date_from: "",
                  separation_date_to: "",
                  length_of_stay: [],
                  assigned_by:[],
                  assigned_to: [],
                  audit_ref_no:[],
                  uploaded_by_user_name : [],
                  hcp_line_updated_at : [],
                  short_description:[],
                  case_mix_speciality:[],
                  drg:[]
                });
              //sessionStorage.setItem("flagStatus",flagauditRows);
              // Clear existing rows and reset pagination
              //setIsRowsLoading(true);
              setAuditRows([]);
              setPage(1);
              setHasMore(true);

              // Fetch flagged rows
              // getAuditRowsData(1);
              recall_episode({ page_number: 1 })
                .then((res) => {
                  //console.log("auditRows Res",res);
                  if (res.data.message) {
                    toast.error(res.data.message);
                  }
                  //getAuditRows({});
                  // setAuditRows(res.res.audited_rows)
                  //setAuditRows(res.data.data.audited_rows); // Create a new array
                  // setflagAuditRows(true);
                })
                .catch((err) => {
                  console.log("Error: " + err.message);
                });
            }}
          >
            Recalled Episodes
          </span>
        </div>
      )}
        <div>
      <IconButton
        onClick={handleOpen}
        sx={{
          backgroundColor: "transparent",
          border: "none",
          height: 25,
          boxShadow: "none",
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <HideImageIcon sx={{ color: "#032F49" ,ml:1.2}} />
        {/* <p   style={{ marginTop:"20px",fontSize:"14px",color:"#0b192c",fontWeight:"520" }}>Select Preferred Columns</p> */}
        <Tooltip title="Select Preferred Columns">
  <p
    style={{
      marginTop: "15px",
      fontSize: "14px",
      color: "#0b192c",
      fontWeight: 520,
      whiteSpace: "nowrap", 
      overflow: "hidden",     
      textOverflow: "ellipsis",
      maxWidth: "150px",  
      cursor: "pointer",  
    }}
  >
    Select Preferred Columns
  </p>
</Tooltip>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 238,
            maxHeight: 280,
            overflowY: "auto",
          },
        }}
      >
        <List
          subheader={
            <ListSubheader disableSticky>
              <TextField
                size="small"
                placeholder="Search column options"
                variant="standard"
                sx={{ width: "90%", mt: 1}}
                onChange={(e) => setSearch(e.target.value)}
              />
            </ListSubheader>
          }
        >
          {filteredColumns.map((column) => (
            <MenuItem
              key={column.id}
              disableRipple
              sx={{ pl: 1,
                 transition: "background-color 0.2s",
                 borderLeft: "4px solid #e0f7fa",
                 py: 0,                
                 "&:hover": {
                        backgroundColor: "#f1f1fb",
                         borderLeft: "4px solid #28A671",
                         borderRadius:'5px',
                          pl: 1,
                     },
                   }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={column.checked}
                    onChange={() => toggleColumnSelection(column.id)}
                    sx={{px: 2, py: 1,"& .MuiSvgIcon-root": { fontSize: 16 }}}
                  />
                }
                label={column.label}
                sx={{ pl: 1,
                  "& .MuiFormControlLabel-label": {
                   fontSize: "13px", 
                    },
                  
                 "&:hover": {
                          pl: 1,
                     },
                }}
                
              />
            </MenuItem>
          ))}
          <Divider />
        </List>
      </Menu>
    </div>
      {/* select column csv dowload */}
      <div style={{marginTop:"25px"}}>
      <IconButton
        onClick={handleDowloadColumnCsvOpen}
        sx={{
          backgroundColor: "transparent",
          border: "none",
          height: 25,
          boxShadow: "none",
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <FileDownloadIcon sx={{ color: "#032F49" ,ml:1}} />
        {/* <p style={{ marginTop:"30px",fontSize:"14px",color:"#0b192c",fontWeight:"520" }}>Select Preferred Columns to export csv</p> */}
        <Tooltip title="Select Preferred Columns to export csv">
  <p
    style={{
      marginTop: "15px",
      fontSize: "14px",
      color: "#0b192c",
      fontWeight: 520,
      whiteSpace: "nowrap", 
      overflow: "hidden",     
      textOverflow: "ellipsis",
      maxWidth: "150px",  
      cursor: "pointer",  
    }}
  >
    Select Preferred Columns to export csv
  </p>
</Tooltip>
      </IconButton>

      <Menu
        anchorEl={csvColumn}
        open={Boolean(csvColumn)}
        onClose={handleDowloadColumnCsvClose}
        PaperProps={{
          sx: {
            width: 238, 
            maxHeight: 280,
            overflowY: "auto",
            whiteSpace: "nowrap", 
            overflowX: "hidden",
            textOverflow: "ellipsis"
          },
        }}
      >
        <List
         sx={{ maxHeight: 200, overflowY: "auto" }}
      onScroll={(e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        const isBottom = scrollHeight - scrollTop <= clientHeight + 5;

        if (isBottom && hasMoreCsvColumns && !loadingMoreCsvColumns) {
          handleCsvColumns(csvCurrentPage, true);
        }
      }}
          subheader={
            <ListSubheader disableSticky>
              <TextField
                size="small"
                placeholder="Search column options"
                variant="standard"
                sx={{ width: "90%", mt: 1}}
                // onChange={(e) => setcsvColumnSearch(e.target.value)}
                 onChange={(e) => handleSearchChange(e.target.value)}
              />
            </ListSubheader>
          }
        >
       <Box sx ={{display:"flex",alignItems:"center",ml:1.9}}>
        <Checkbox size="small" sx={{ "& .MuiSvgIcon-root": { fontSize: 17 } }}
        //  checked = {checkedStoreColumns.length > 0 && checkedStoreColumns.length === storeCsvColumns.length}
         checked={
    appliedFilters.selectAll &&
    appliedFilters.deselected_list.length === 0 
  }
        //  indeterminate ={
        //   checkedStoreColumns.length > 0 && checkedStoreColumns.length < storeCsvColumns.length
        //  }
        indeterminate={
    (appliedFilters.selectAll && appliedFilters.deselected_list.length > 0) || 
    (!appliedFilters.selectAll &&
      checkedStoreColumns.length > 0 &&
      checkedStoreColumns.length < storeCsvColumns.length) 
  }
         onChange={handleSelectAll}
       
       /> <Typography sx={{fontSize:14}}>Select All</Typography></Box>  
          {storeCsvColumns.map((column) => (
            <MenuItem
              key={column.id}
              disableRipple
              sx={{ pl: 1,
                 transition: "background-color 0.2s",
                 borderLeft: "4px solid #e0f7fa",
                  py: 0,  
                
                 "&:hover": {
                        backgroundColor: "#f1f1fb",
                         borderLeft: "4px solid #28A671",
                         borderRadius:'5px',
                          pl: 1,
                     },
                   }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                  //  checked={checkedStoreColumns.includes(column.key)}
                   checked={
                      appliedFilters.selectAll
                      ? !appliedFilters.deselected_list.includes(column.key) // ✅ all checked except deselected
                           : checkedStoreColumns.includes(column.key)             // ✅ normal mode
                        }
                  sx={{ px: 2, py: 1 ,"& .MuiSvgIcon-root": { fontSize: 17 }}}
                  onChange={() => storeColumnSelection(column.key)}
                  />
                }
                label={column.value}
                sx={{ pl: 1 ,
                   "& .MuiFormControlLabel-label": {
                   fontSize: "13px", 
                    },
                  
                 "&:hover": {
                          pl: 1,
                     },
                }}
              />
            </MenuItem>
          ))}
          <Divider />
          {loadingMoreCsvColumns && (
    <div style={{ textAlign: "center", padding: "10px", color: "#666" }}>
      <CircularProgress size={20} sx={{color:"black"}} />
    </div>
  )}
        </List>
      </Menu>
    </div>
    </div>
  );
}
